import { memo, type ReactNode } from 'react';

import type { Upload } from '@didaskill/domain/uploads/types';

import { ResourcePicture } from '../picture/ResourcePicture';
import * as styles from './ResourceCard.styles';

export type ResourceCardProps = {
  pictureTag?: ReactNode;
  picture?: Upload;
  children?: ReactNode;
};

export const ResourceCardBase = ({ picture, children, pictureTag }: ResourceCardProps) => {
  return (
    <div css={styles.container}>
      <ResourcePicture picture={picture}>
        {pictureTag && <div css={styles.tag}>{pictureTag}</div>}
      </ResourcePicture>

      <div css={styles.descriptionContainer}>{children}</div>
    </div>
  );
};

ResourceCardBase.displayName = 'ResourceCard';

export const ResourceCard = memo(ResourceCardBase);
